import {
  fetchAllAccessories,
  selectAllAccessories,
} from "features/admin/Accessories/accessoriesAdminSlice";
import clsx from "clsx";
import {
  fetchProductsList,
  selectProductsIds,
} from "features/admin/Products/productsAdminSlice";
import { ObjectType } from "features/types";
import React from "react";
import { RootState } from "store/rootReducer";
import styled from "styled-components/macro";
import AddOrderProductTable from "./AddOrderProductTable";
import { colors } from "@material-ui/core";
import { omit } from "features/utils";

interface ProductTabsProps {
  getValues: any;
  setValue: any;
  activeValues?: any;
}

const config: Record<
  Exclude<ObjectType, ObjectType.multisplit>,
  { selector: (state: RootState) => any; fetchFN: any; title: string }
> = {
  [ObjectType.product]: {
    selector: selectProductsIds,
    fetchFN: fetchProductsList,
    title: "Климатици",
  },
  [ObjectType.accessory]: {
    selector: selectAllAccessories,
    fetchFN: fetchAllAccessories,
    title: "Аксесоари",
  },
};

const setActiveByObjectType = (
  activeObjectType: string,
  objectType: string
) => {
  return clsx({ active: activeObjectType === objectType });
};

const ProductTabs: React.FC<ProductTabsProps> = ({
  getValues,
  setValue,
  activeValues,
}) => {
  const [activeObjectType, setObjectType] = React.useState<string>(
    ObjectType.product
  );

  const handleTabChange = (objectType: string) => {
    setObjectType(objectType);
  };

  const objectTypes = Object.keys(omit(ObjectType, ObjectType.multisplit));

  return (
    <TabsContainer>
      <TabsRow>
        {objectTypes.map((objectType) => {
          return (
            <Tab
              className={setActiveByObjectType(activeObjectType, objectType)}
              onClick={() => handleTabChange(objectType)}
            >
              {
                config[objectType as Exclude<ObjectType, ObjectType.multisplit>]
                  .title
              }
            </Tab>
          );
        })}
      </TabsRow>
      {objectTypes.map((objectType: string) => {
        return (
          <TabContent
            className={setActiveByObjectType(activeObjectType, objectType)}
          >
            <AddOrderProductTable
              objectType={objectType}
              selector={
                config[objectType as Exclude<ObjectType, ObjectType.multisplit>]
                  .selector
              }
              fetchFN={
                config[objectType as Exclude<ObjectType, ObjectType.multisplit>]
                  .fetchFN
              }
              setValue={setValue}
              getValues={getValues}
              activeValues={activeValues}
            />
          </TabContent>
        );
      })}
    </TabsContainer>
  );
};

const TabsContainer = styled.div`
  margin-top: 30px;
  flex: 1 1 100%;

  .hidden {
    display: none;
  }
`;

const TabsRow = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
`;

const Tab = styled.div`
  padding: 10px;
  border: 1px solid ${colors.grey[400]};
  transition: 0.2s all;

  &.active {
    background-color: ${colors.blue[800]};
    color: white;
  }

  & + & {
    margin-left: 10px;
  }
`;

const TabContent = styled.div`
  flex: 1;
  display: none;

  &.active {
    display: block;
  }
`;

export default ProductTabs;
